import styles from './Wordmark.module.css';

interface Props {
  size?: 'sm' | 'md' | 'lg';
}

export function Wordmark({ size = 'md' }: Props) {
  return (
    <span className={styles.wordmark} data-size={size}>
      Linq<span className={styles.accent}>a</span>ge
    </span>
  );
}
